import { gsap as i } from "gsap";
import { ScrollTrigger as t } from "gsap/dist/ScrollTrigger.js";
function m(e, r, s, p) {
  var o, c = !1, n = 0;
  function u() {
    o && clearTimeout(o);
  }
  function b() {
    u(), c = !0;
  }
  function h() {
    for (var f = arguments.length, g = new Array(f), l = 0; l < f; l++)
      g[l] = arguments[l];
    var T = this, d = Date.now() - n;
    if (c)
      return;
    function a() {
      n = Date.now(), s.apply(T, g);
    }
    u(), d > e ? a() : o = setTimeout(a, e - d);
  }
  return h.cancel = b, h;
}
i.registerPlugin(t);
const z = {
  data() {
    return {
      storedAnimations: [],
      resizeObserver: null,
      resizeObserverElements: []
    };
  },
  beforeUnmount() {
    this.clearAnimations(), this.resizeObserver && this.resizeObserverElements.forEach((e) => {
      this.resizeObserver.unobserve(e);
    });
  },
  mounted() {
    this.createResizeObserver(), this.observeResizeOf(document.querySelector("body"));
  },
  methods: {
    createResizeObserver() {
      const e = m(700, !1, () => {
        t.refresh(!0);
      });
      this.resizeObserver = new ResizeObserver(e);
    },
    observeResizeOf(e) {
      !e || this.resizeObserverElements.includes(e) || (this.resizeObserver.observe(e), this.resizeObserverElements.push(e));
    },
    createTimeline(e) {
      const r = i.timeline(e);
      return this.storedAnimations.push(r), this.checkCustomScroller(e.scrollTrigger), r;
    },
    createTweenFrom(e, r) {
      const s = i.from(e, r);
      return this.storedAnimations.push(s), this.checkCustomScroller(r.scrollTrigger), s;
    },
    createTweenTo(e, r) {
      const s = i.to(e, r);
      return this.storedAnimations.push(s), this.checkCustomScroller(r.scrollTrigger), s;
    },
    createMediaScrollTrigger(e) {
      const r = t.matchMedia(e);
      return this.storedAnimations.push(r), r;
    },
    createScrollTrigger(e) {
      const r = t.create(e);
      return this.storedAnimations.push(r), this.checkCustomScroller(e), r;
    },
    resetAndClearAnimations() {
      this.storedAnimations.forEach((e) => {
        e && (e instanceof t && e.disable(!0), e.scrollTrigger instanceof t && (e.scrollTrigger.disable(!0), e.scrollTrigger.kill !== void 0 && e.scrollTrigger.kill(!0)), e.kill !== void 0 && e.kill(!0), e._targets && i.set(e._targets, { clearProps: !0 }), e.trigger && i.set(e.trigger, { clearProps: !0 }));
      }), this.storedAnimations = [];
    },
    clearAnimations() {
      this.storedAnimations.forEach((e) => {
        e.scrollTrigger instanceof t && e.scrollTrigger.kill !== void 0 && e.scrollTrigger.kill(!0), e && e.kill !== void 0 && e.kill(!0);
      }), this.storedAnimations = [];
    },
    checkCustomScroller(e) {
      if (!e || !e.scroller) return;
      const r = typeof e.scroller == "string" ? document.querySelector(e.scroller) : e.scroller;
      this.observeResizeOf(r);
    }
  }
};
export {
  z as default
};
